<template>
  <div class="flexColumn category-filter">
    <div class="filter-box mb11 flexRowS">
      <span class="label-name mr35" style="margin-top: -1px">
        <template v-if="$attrs.title.length == 2">
          {{ $attrs.title[0] }}
          &nbsp;&nbsp;&nbsp;
          {{ $attrs.title[1] }}
        </template>
        <template v-else>
          {{ $attrs.title }}
        </template>
      </span>
      <div class="filter-box-content">
        <div class="filter-left flexRowS">
          <div class="filter-item" :class="{ checked: isAllSelected }" @click="selectAll">全部</div>
          <div
            class="filter-item"
            v-for="item in level1Data"
            :key="item.value"
            :class="{ checked: selectedValues.includes(item.value) }"
            @click="changeFilter(item)"
          >
            {{ item.label }}
          </div>
        </div>
        <div class="filter-box-right" v-if="isLevel1More" @click="level1More = !level1More">
          更多
          <van-icon class="icon" :class="{ up: !level1More }" name="arrow-down" />
        </div>
      </div>
    </div>
    <div
      class="level2-box flexRowSB"
      v-if="$attrs.category2List && $attrs.category2List.length > 0"
    >
      <div class="level2-box-left flexRowS" :class="{ openDiv: !level2More, closeDiv: level2More }" ref="level2Box">
        <div class="filter-item" :class="{ checked: isAllSelected2 }" @click="select2All">全部</div>
        <div
          class="filter-item"
          v-for="item in level2List"
          :key="item.value"
          :class="{ checked: selectedLevel2Values.includes(item.value) }"
          @click="change2Filter(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div
        class="filter-box-right"
        @click="level2More = !level2More"
        v-if="isShowMore"
      >
        <van-icon class="icon" :class="{ up: !level2More }" name="arrow-down" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryFilter",
  props: {
    // 接收父组件v-model传递的值
    value: {
      type: Array,
      default: () => [],
    },
    // 二级分类数据，使用.sync修饰符进行双向绑定
    level2Data: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    "$attrs.category2List": {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.level2Box) {
            const offsetWidth = this.$refs.level2Box.offsetWidth
            this.isShowMore = offsetWidth > 920
          } else {
            this.isShowMore = false
          }
          
        })
      },
      immediate: true,
    },
  },
  data() {
    return {
      level1More: true,
      level2More: true,
      isShowMore: true
    }
  },
  computed: {
    // 当前选中的值
    selectedValues() {
      return this.value || []
    },
    selectedLevel2Values() {
      return this.level2Data || []
    },
    // 是否全选
    isAllSelected() {
      return this.selectedValues.length === 0
    },
    isAllSelected2() {
      return this.selectedLevel2Values.length === 0
    },
    isLevel1More() {
      return this.$attrs.typeData.length > 4
    },
    level1Data() {
      if (this.level1More) {
        return this.$attrs.typeData.slice(0, 4)
      }
      return this.$attrs.typeData
    },
    isLevel2More() {
      return this.$attrs.category2List.length > 4
    },
    level2List() {
      // if (this.level2More) {
      //   return this.$attrs.category2List.slice(0, 4)
      // }
      return this.$attrs.category2List
    },
  },
  methods: {
    // 判断是否显示更多
    isShowMoreFn() {
      
    },
    // 选择全部
    selectAll() {
      this.$emit("input", [])
      this.$emit("getlevel2List", [])
      this.$emit("changeFilter", [""])
      this.select2All()
    },
    // 改变筛选条件
    changeFilter(item) {
      this.level2More = true
      let arr = [...this.selectedValues] // 使用当前选中的值
      if (this.$attrs.select === "checkbox") {
        // 多选模式
        if (arr.includes(item.value)) {
          // 如果已选中，则移除
          arr = arr.filter(val => val !== item.value)
        } else {
          // 如果未选中，则添加
          arr.push(item.value)
        }
      } else {
        // 单选模式
        arr = [item.value]
      }
      // 向父组件发送新值
      this.$emit("input", arr)
      this.$emit("getlevel2List", arr)
      this.$emit("changeFilter", arr)
      this.$emit("update:level2Data", [])
    },
    change2Filter(item) {
      this.$emit("update:level2Data", [item.value])
      this.$emit("changeFilter2", [item.value])
    },
    select2All() {
      this.$emit("update:level2Data", [])
      this.$emit("changeFilter2", [])
    },
  },
}
</script>

<style lang="less" scoped>
.category-filter {
  width: 100%;
  border-bottom: 1px solid #f0f2f4;
  padding-top: 21px;
}
.filter-box {
  width: 100%;
}
.label-name {
  align-self: flex-start;
  position: relative;
  font-family: YouSheBiaoTiHei;
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  width: 60px;
  white-space: nowrap;
}
.filter-box-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .filter-left {
    display: flex;
    flex-wrap: wrap;
    .filter-item {
      font-size: 14px;
      color: #333333;
      padding: 5px 26px;
      cursor: pointer;
      flex: 0 0 auto;
      margin-bottom: 10px;
    }
    .checked {
      background: #3994ff;
      border-radius: 100px;
      color: #fff;
    }
  }
}
.filter-box-right {
  flex: 0 0 auto;
  font-size: 12px;
  color: #999999;
  cursor: pointer;
  align-self: flex-start;
  padding: 5px 0;
}
.up {
  transform: rotate(180deg);
}
.level2-box {
  padding-left: 117px;
  padding-top: 16px;
  background: #fbfaff;
  .level2-box-left {
    display: flex;
    flex-wrap: wrap;
  }
  .filter-item {
    font-size: 14px;
    color: #666666;
    margin-right: 57px;
    flex: 0 0 auto;
    padding-bottom: 24px;
    cursor: pointer;
  }
  .checked {
    color: #3994ff;
  }

  .filter-box-right {
    flex: 0 0 auto;
    font-size: 12px;
    color: #999999;
    cursor: pointer;
    align-self: flex-start;
    padding: 5px 0;
  }
}

.openDiv {
  height: auto;
}
.closeDiv {
  height: 45px;
  overflow: hidden;
}
</style>
